import { supabase } from '@/lib/supabase'

export interface TotpFactor {
  id: string
  status: 'verified' | 'unverified'
  friendly_name?: string
}

export const mfaService = {
  async listTotpFactors(): Promise<TotpFactor[]> {
    const { data, error } = await supabase.auth.mfa.listFactors()
    if (error) throw error
    return (data.totp ?? []) as TotpFactor[]
  },

  async getVerifiedFactor(): Promise<TotpFactor | null> {
    const factors = await mfaService.listTotpFactors()
    return factors.find(f => f.status === 'verified') ?? null
  },

  async getAssuranceLevel() {
    const { data, error } = await supabase.auth.mfa.getAuthenticatorAssuranceLevel()
    if (error) throw error
    return data
  },

  async enroll() {
    const { data, error } = await supabase.auth.mfa.enroll({ factorType: 'totp' })
    if (error) throw error
    // data.totp.qr_code: SVG string, data.totp.secret: manual key, data.id: factorId
    return data
  },

  async challengeAndVerify(factorId: string, code: string) {
    const { data, error } = await supabase.auth.mfa.challengeAndVerify({ factorId, code })
    if (error) throw error
    return data
  },

  async unenroll(factorId: string) {
    const { data, error } = await supabase.auth.mfa.unenroll({ factorId })
    if (error) throw error
    return data
  },
}
